import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface CartRecommendationTabEntityParams {
  order_id: number;
  distributor_id: number;
}
export class CartRecommendationTabEntity extends BaseEntityClass {
  order_id: number;
  distributor_id: number;
  constructor(params: CartRecommendationTabEntityParams) {
    super();
    this.type = "cart_recommendation_tab";
    this.entity_version = 2;
    this.order_id = params.order_id;
    this.distributor_id = params.distributor_id;
  }
}
